import {
  FaCalendarAlt,
  FaChartLine,
  FaLayerGroup,
  FaUser,
} from "react-icons/fa";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { Link, useLocation, useNavigate } from "react-router";
import { IoIosArrowForward } from "react-icons/io";
import { MdSpaceDashboard } from "react-icons/md";
import { RiCoupon2Fill } from "react-icons/ri";
import styles from "./Sidebar.module.scss";

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div className={styles.mainContainer}>
      <div className={styles.linksContainer}>
        <Link
          to="/admin"
          className={`${styles.link} ${
            location.pathname === "/admin" || location.pathname === "/admin/"
              ? styles.active
              : ""
          }`}
        >
          <MdSpaceDashboard />
          <p>Home</p>
        </Link>
        <Link
          to="/admin/buildings"
          className={`${styles.link} ${location.pathname?.includes("/admin/buildings") ? styles.active : ""}`}
        >
          <FaCalendarAlt />
          <p>Buildings</p>
        </Link>
        <Link
          to="/admin/groups"
          className={`${styles.link} ${location.pathname?.includes("/admin/groups") ? styles.active : ""}`}
        >
          <FaLayerGroup />
          <p>Groups</p>
        </Link>
        <Link
          to="/admin/members"
          className={`${styles.link} ${location.pathname?.includes("/admin/members") ? styles.active : ""}`}
        >
          <FaUser />
          <p>Members</p>
        </Link>

        <Link
          to="/admin/users"
          className={`${styles.link} ${location.pathname?.includes("/admin/users") ? styles.active : ""}`}
        >
          <FaUser />
          <p>Users</p>
        </Link>

        <Link
          to="/admin/coupons"
          className={`${styles.link} ${location.pathname?.includes("/admin/coupons") ? styles.active : ""}`}
        >
          <RiCoupon2Fill />
          <p>Coupons</p>
        </Link>

        <Menu
          menuClassName={styles.sidebarDropdown}
          dir="right"
          align="end"
          viewScroll="auto"
          arrow={true}
          transition={true}
          portal={true}
          direction="left"
          menuButton={
            <MenuButton
              className={`${styles.link} ${location.pathname?.includes("/admin/reports") ? styles.active : ""}`}
            >
              <div className={styles.linkTextContainer}>
                <span className={styles.linkText}>
                  <FaChartLine />
                  <p>Reports</p>
                </span>
                <span className={styles.menuIcon}>
                  <IoIosArrowForward />
                </span>
              </div>
            </MenuButton>
          }
        >
          <MenuItem
            onClick={() => {
              if (location.pathname === "/admin/reports/package") {
                return;
              }
              navigate("/admin/reports/package");
            }}
          >
            Package Subscriptions
          </MenuItem>
          <MenuItem
            onClick={() => {
              if (location.pathname === "/admin/reports/residents") {
                return;
              }
              navigate("/admin/reports/residents");
            }}
          >
            Residents
          </MenuItem>
          <MenuItem
            onClick={() => {
              if (location.pathname === "/admin/reports/members") {
                return;
              }
              navigate("/admin/reports/members");
            }}
          >
            Members
          </MenuItem>

          <MenuItem
            onClick={() => {
              if (location.pathname === "/admin/reports/futurebookings") {
                return;
              }
              navigate("/admin/reports/futurebookings");
            }}
          >
            Future Bookings
          </MenuItem>

          <MenuItem
            onClick={() => {
              if (location.pathname === "/admin/reports/profit") {
                return;
              }
              navigate("/admin/reports/profit");
            }}
          >
            Profit
          </MenuItem>

          <MenuItem
            onClick={() => {
              if (location.pathname === "/admin/reports/pastbookings") {
                return;
              }
              navigate("/admin/reports/pastbookings");
            }}
          >
            Past Bookings
          </MenuItem>

          <MenuItem
            onClick={() => {
              if (location.pathname === "/admin/reports/doorhistory") {
                return;
              }
              navigate("/admin/reports/doorhistory");
            }}
          >
            Door History
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
}

export default Sidebar;
